import { Card, useGet } from '@enkla-gui'
import React, { useContext } from 'react'

import ActionItems from '@/components/dashboard/ActionItems'
import ActiveTickets from '@/components/dashboard/ActiveTickets'
import EconomyMetrics from '@/components/dashboard/EconomyMetrics'
import Greeting from '@components/layout/Greeting'
import PropertyMetrics from '@/components/dashboard/PropertyMetrics'
import RevenueChart from '@/components/dashboard/RevenueChart'
import UpcomingWeek from '../../components/help/upcoming'
import { UserContext } from '@/App'

export default function Dashboard() {
  const { user, billable } = useContext(UserContext)
  const { data: projected } = useGet({ endpoint: 'api/economy/projected' })
  const { data: economyStats } = useGet({ endpoint: 'api/economy/stats' })
  return (
    <>
      <Greeting />
      {user.show_onboarding_in_sidebar && user.billable.membership > 0 && (
        <div class='welcome-section'>
          <Card>
            <div class='welcome-hero'>
              <div class='welcome-hero-icon'>
                <i class='fas fa-rocket' />
              </div>
              <div class='welcome-hero-text'>
                <h3>Nu kör vi!</h3>
                <p>
                  Varmt välkommen till Enkla Fastigheter – tack för att du har valt att prova oss!
                  Din resa mot en enklare och effektivare fastighetsförvaltning tar nu fart.
                </p>
                <p>
                  Under din 30-dagars gratis provperiod kan du utforska alla funktioner i din egen takt.
                  Vi finns här för att stötta dig längs vägen.
                </p>
              </div>
            </div>
          </Card>
          <div class='welcome-actions'>
            <a href='/#!/onboard' class='welcome-action-card'>
              <div class='welcome-action-icon welcome-action-blue'>
                <i class='fas fa-play-circle' />
              </div>
              <div class='welcome-action-text'>
                <span class='welcome-action-value'>Kom igång</span>
                <span class='welcome-action-label'>Steg-för-steg-guide</span>
              </div>
            </a>
            <a href='/#!/help/faq' class='welcome-action-card'>
              <div class='welcome-action-icon welcome-action-teal'>
                <i class='fas fa-question-circle' />
              </div>
              <div class='welcome-action-text'>
                <span class='welcome-action-value'>Vanliga frågor</span>
                <span class='welcome-action-label'>Hitta svar direkt</span>
              </div>
            </a>
            <a href='/#!/help/contact' class='welcome-action-card'>
              <div class='welcome-action-icon welcome-action-purple'>
                <i class='fas fa-paper-plane' />
              </div>
              <div class='welcome-action-text'>
                <span class='welcome-action-value'>Kontakta oss</span>
                <span class='welcome-action-label'>Vi hjälper dig gärna</span>
              </div>
            </a>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-lg-6">
          <ActionItems billable={billable} loading={!billable?.id} />
          <ActiveTickets />
          <UpcomingWeek />
        </div>
        <div className="col-lg-6">
          <PropertyMetrics economyStats={economyStats} loading={!economyStats} />
          <EconomyMetrics economyStats={economyStats} loading={!economyStats} />
          <RevenueChart projected={projected} loading={!projected} />
        </div>
      </div>
    </>
  )
}
